'use strict'
import { Toast } from 'vant'

const PARENT_KEY = 'parentId'
const MUTEX_KEY = 'mutexId'
let isMutexList = []

/**
 * project 体检项目对象属性说明
 *
 * id 体检项目ID
 * item 体检项目名称
 * inspectionSignificance 体检项目简介
 * mutexCode 体检项目互斥组CODE,多个以","相隔
 * mutexId 体检项目互斥组ID,多个以","相隔
 * addWarning 是否显示特别说明  1 有  0 没有
 * warningInfo 体检项目特别说明内容
 * discountPrice 折后价格
 * price 价格
 * orderNum 排序号
 * parentId 父级ID,以此构建树状结构
 * parentName 父级名称
 * recalculate 是否可替换 1 可替换 0 不可替换   //应该为 是否重复计费  1 可重复计费   0不可重复计费
 * relationships 体检项目的关联项目ID ,多个以","相隔(存在materialList中)
 * typable 数据类型 0 父级目录 1 体检项目
 *
 * packable 是否为当前已选择体检套餐包含的项目 1 已存在套餐中 0 未存在套餐中
 * recommendable 是否为推荐体检项目 1 推荐项目 0 普通项目
 *
 * base 是否为基础项目 1 基础项目 0 普通项目
 * 以下属性只有基础项目才有:
 * revoke 撤销操作标识,1 允许撤销 0 禁止撤销
 * delectable 是否可删除 1 可删除 0 不可删除
 */

/***
 * project 当前用户点击选择的项目
 * checkedList 所有被选中的项目 （ 不含关联项目）
 * ProjectList 所有的体检项目
 * MutexList 所有的互斥组
 * materialListAll 所有的关联项目
 * checkedMaterialProjectList 所有用户自选的关联项目
 * productMaterialProjectList  所有主套餐中的关联项目
 * projectMutexList   【当前用户点击选择的项目（project）】 的已选中互斥项目
 * isReplace  是否可以替换
 ***/
function getCheckedProject (project, checkedList, ProjectList, MutexList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, productPrice, checkedPrice, xproductMaterialProjectList) {
  /**
   *  1.另外保存一份数据：原因 技术架构所致 vuex  需要通过  mutations 改变数据
   *  2.业务：
   *   2.1  先看用户所选项目是否有互斥项目        2.1.1  不含互斥项目      2.1.2  含互斥项目 //查询是否含有 被选中的，不能被替换的互斥项目
   *   2.2 看关联项目
   *   待处理
   **/
  let projectIDList = JSON.parse(JSON.stringify(checkedList)) //当前选中的所有项目
  let productMaterial = JSON.parse(JSON.stringify(productMaterialProjectList)) //套餐内的关联项目
  let xproductMaterial = JSON.parse(JSON.stringify(xproductMaterialProjectList)) //x套餐内的关联项目
  let materialProjectList = JSON.parse(JSON.stringify(checkedMaterialProjectList)) //当前选中的所有关联项目，不含套餐内关联项目
  let projectMutexListALL = getCheckedMutex(project, MutexList, ProjectList) //获取用户选择的当前项目的互斥项目
  let projectMutexList = projectMutexListALL.filter(obj => { return checkedList.find(item => { return item.id === obj.id }) })
  let materialListAllList = JSON.parse(JSON.stringify(materialListAll))
  if (!isMutexList.length) isMutexList = MutexList
  if (!projectMutexList.length) { //无互斥项目
    console.log('无互斥项目')
    if (project.relationships) { //有关联项目
      setMaterialList(project, projectIDList, ProjectList, materialListAllList, materialProjectList, productMaterial, xproductMaterial)
    }
    projectIDList.push(project)
  } else { //有互斥项目
    console.log('有互斥项目')
    let showText = ''
    let mutexRelationships= []
    let  initMutexListALL= JSON.parse(JSON.stringify(projectMutexListALL))
    projectMutexListALL.forEach(obj=>{
     if(obj.relationships){
       let  isMutexListAll = getMaterialList(obj, materialListAll, materialProjectList, projectIDList, [])
       mutexRelationships = mutexRelationships.concat(isMutexListAll)
     }
    })
    console.log(mutexRelationships)
    let list = []
      list = checkedList.filter(obj => { return mutexRelationships.includes(obj.id)})
    if(project.packable === '1' || project.packable === 'x') list = list.concat(materialProjectList.filter(obj => { return mutexRelationships.includes(obj.id)}))

    console.log(list)
    list.forEach(obj=>{
      projectMutexList.push(obj)
    })
    let data = projectMutexList.filter($obj => { return $obj.packable === '1' })
    let price = data && data.length ? data[0].price : 0
    let canReplace = initMutexListALL.some($obj => { return $obj.isReplace === '0' || (($obj.packable === '1' && project.price < $obj.price) || (project.price && project.price < price)) }) //是否包含不可替换的    || ($obj.isReplace === '1'&&$obj.discountPrice >= project.discountPrice)

    if (canReplace) {
      projectMutexList.forEach(obj => {
        if (obj.isReplace === '0' || ((obj.packable === '1' && project.price < obj.price) || (project.price && project.price < price))) {
          showText += showText ? '、' + obj.item : obj.item
        }
      })
      Toast.fail({
        duration: 3000,
        forbidClick: true,
        message: `该项目与【${showText}】不能同时选择`
      })
    } else {
      console.log(JSON.parse(JSON.stringify(projectMutexList)))
    if(project.packable !== '1' && project.packable !== 'x')
      projectMutexList = projectMutexList.filter(obj=>{
        return  initMutexListALL.some($obj=>{return $obj.id === obj.id  }) || ((obj.packable === '1' || obj.packable === 'x') && obj.recalculate.toString() !== '1'  && (!projectIDList.some($t=>{return ($t.packable === '1' || $t.packable === 'x')  && $t.relationships  && $t.relationships.split(',').includes(obj.id) && !projectMutexList.some($obj=>{return $obj.id === $t.id})  })))
      })
    console.log(JSON.stringify(projectIDList))

      if (projectMutexList.length) mutexReplace(projectMutexList, projectIDList, materialListAll, materialProjectList, productMaterial, xproductMaterial) // 互斥掉项目
      if (project.relationships) setMaterialList(project, projectIDList, ProjectList, materialListAllList, materialProjectList, productMaterial, xproductMaterial)

      projectIDList.push(project)
    }
  }
  return {
    xproductMaterial: xproductMaterial,
    productMaterial: productMaterial,
    checkedmaterialList: materialProjectList,
    project: projectIDList
  }
}

function getCheckedProjectMUTEX (projectList, checkedList, ProjectList, MutexList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, productPrice, checkedPrice, xproductMaterialProjectList) {
  let projectIDList = JSON.parse(JSON.stringify(checkedList))
  let productMaterial = JSON.parse(JSON.stringify(productMaterialProjectList))
  let xproductMaterial = JSON.parse(JSON.stringify(xproductMaterialProjectList))
  let materialProjectList = JSON.parse(JSON.stringify(checkedMaterialProjectList))
  projectList.forEach(obj => {
    let params = getCheckedProject(obj, projectIDList, ProjectList, MutexList, materialListAll, materialProjectList, productMaterial, productPrice, checkedPrice, xproductMaterial)
    projectIDList = params.project || []
    productMaterial = params.productMaterial || []
    xproductMaterial = params.xproductMaterial || []
    materialProjectList = params.checkedmaterialList || []
  })
  return {
    xproductMaterial: xproductMaterial,
    productMaterial: productMaterial,
    checkedmaterialList: materialProjectList,
    project: projectIDList
  }
}

function getUnSelectProject (project, checkedList, projectList, MutexList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, productPrice, checkedPrice, xproductMaterialProjectList) {
  /**
   * 取消
   * 1.判断是不是套餐项目（套餐项目不能被取消）
   * 2.找互斥组       2.1 不含互斥组：下一步      2.2 含互斥组： 若互斥组中有为套餐项目的   则直接进行选套餐项目的处理  ///  由于有2.2存在，最好在vuex中处理
   * 3.找关联项目    3.1 不含关联项目 则直接取消    3.2 含关联项目 则先取消关联项目，再取消当前项目
   *  当前方法 取消含不为套餐的互斥组 或者 不含互斥组  的项目
   **/
  let projectIDList = JSON.parse(JSON.stringify(checkedList)) //当前选中的所有项目
  let productMaterial = JSON.parse(JSON.stringify(productMaterialProjectList)) //套餐内的关联项目
  let xproductMaterial = JSON.parse(JSON.stringify(xproductMaterialProjectList)) //套餐内的关联项目
  let materialProjectList = JSON.parse(JSON.stringify(checkedMaterialProjectList)) //当前选中的所有关联项目
  let isMaterialListCo = getMaterialList(project, materialListAll, materialProjectList, projectIDList, [])
  projectIDList = projectIDList.filter(obj => { return obj.id !== project.id })
  console.log(projectIDList)

  let parojectMuetexList = []
  let parojectMuetex = (project[MUTEX_KEY] && project[MUTEX_KEY].split(',')) || []
  parojectMuetex.forEach(ids => {
    if (MutexList[ids]) {
      for (let key in MutexList[ids]) {
        let pro = projectList.find(obj => { return key === obj.id && ((obj.isNewRecommend === '1' &&
            projectList.every($item => { return $item.packable !== '1' && obj.packable !== 'x' })) ||
            obj.packable === '1' || obj.packable === 'x' ||
            projectIDList.some($project => { return $project.relationships && $project.relationships.split(',').includes(key) })) &&
            projectIDList.every($project => { return $project.id !== key }) && parojectMuetexList.every($project => { return $project.id !== key }) })
        if (pro && !(MutexList[ids][pro.id] === 0 && MutexList[ids][project.id] === 0)) parojectMuetexList.push(pro)
      }
    }
  })

  let muetexRList = []
  parojectMuetexList.forEach(obj=>{
    muetexRList = muetexRList.concat( getMaterialList(obj, materialListAll, materialProjectList, projectIDList, []))

  })
  console.log(muetexRList)
  projectIDList.forEach($listItem=>{
    if($listItem.packable !== '1' && $listItem.packable !== 'x'){

      let ls = getMaterialList($listItem, materialListAll, materialProjectList, projectIDList, [])
      console.log($listItem, ls)
      isMaterialListCo = isMaterialListCo.filter(obj=>{ return (!ls.includes(obj) || materialProjectList.some($obj=>{ return $obj.id == obj && $obj.recalculate.toString() === '1' } )) || muetexRList.includes(obj)  })
    }
  })
  if (isMaterialListCo && isMaterialListCo.length) {
    isMaterialListCo.forEach($obj => {
      materialProjectList.forEach($item => {
        if ($item.id === $obj) {
          // console.log($item, !projectIDList.some(obj => { return obj.relationships && obj.relationships.split(',').includes($item.id) &&  project.id == obj.id }) ,  !materialProjectList.some(obj => {return ( (obj.relationships && obj.relationships.split(',').includes($item.id)) && !isMaterialListCo.includes(obj.id) && project.id === obj.id )}))
          if ($item.recalculate.toString() === '1') { //重复计费的
            if ($item.count > 1) {
              $item.count -= 1
            } else {
              $item.count = 0

              materialProjectList.splice(materialProjectList.findIndex($t => { return $t.id === $obj }), 1)
            }
          } else {
            // getMaterialList(obj, materialListAll, materialProjectList, projectIDList, [])

              let mIndex = materialProjectList.findIndex($y => { return $y.id === $obj })
              if (mIndex > -1) {
                materialProjectList.splice(mIndex, 1)
              }
              let pIndex = projectIDList.findIndex($y => { return $y.id === $obj })
              if (pIndex > -1) {
                projectIDList.splice(pIndex, 1)
              }
          // }
          //   if (!projectIDList.some(obj => { return (obj.packable !== '1' && obj.packable !== 'x') && obj.relationships && obj.relationships.split(',').includes($item.id) && !isMaterialListCo.includes(obj.id) }) && !materialProjectList.some(obj => { return (obj.relationships && obj.relationships.split(',').includes($item.id) && !isMaterialListCo.includes(obj.id)) })) {

          }
        }
      })
    })
  } //当前项目
  // console.log(JSON.parse(JSON.stringify(materialProjectList)))
  // return
  let allMutexList = projectList.filter(obj => { return isMaterialListCo.includes(obj.id) })
  console.log(allMutexList)

  allMutexList.push(project) //所有关联项目及自身
  allMutexList.forEach(isProject => {
    let mutexpRrojectList = []
    let projectMutexList = (isProject[MUTEX_KEY] && isProject[MUTEX_KEY].split(',')) || []
    projectMutexList.forEach(ids => {
      if (MutexList[ids]) {
        for (let key in MutexList[ids]) {
          let pro = projectList.find(obj => { return key === obj.id && ((obj.isNewRecommend === '1' && projectList.every($item => { return $item.packable !== '1' && obj.packable !== 'x' })) || obj.packable === '1' || obj.packable === 'x' || projectIDList.some($project => { return $project.relationships && $project.relationships.split(',').includes(key) })) && projectIDList.every($project => { return $project.id !== key }) && mutexpRrojectList.every($project => { return $project.id !== key }) })
          if (pro && !(MutexList[ids][pro.id] === 0 && MutexList[ids][isProject.id] === 0)) mutexpRrojectList.push(pro)
        }
      }
    })
    if (mutexpRrojectList.length) {
      var list = []
      mutexpRrojectList.forEach(obj => {
        list =list.concat(getMaterialList(obj, materialListAll, materialProjectList, projectIDList, []))
      })
      mutexpRrojectList =mutexpRrojectList.concat(projectList.filter(obj => { return list.includes(obj.id) && ( obj.packable === '1' || obj.packable === 'x' )&& !mutexpRrojectList.some(item=>{return item.id === obj.id }) }))

      mutexpRrojectList.forEach(obj => {
        if (obj && obj.id !== project.id) {
          if (obj.packable !== '1' && obj.packable !== 'x' && projectIDList.some($project => { return $project.relationships && $project.relationships.split(',').includes(obj.id) })) {
            materialProjectList.push(Object.assign({}, obj, {count: 1}))
          } else {
            projectIDList.push(Object.assign({}, obj, {count: 1}))
          }
          setMaterialList(obj, projectIDList, projectList, materialListAll, materialProjectList, productMaterial, xproductMaterial)
        }
      })
    }
  })

  return {
    xproductMaterial: xproductMaterial,
    productMaterial: productMaterial,
    checkedmaterialList: materialProjectList,
    project: projectIDList
  }
}

function mutexReplace (projectMutexList, projectIDList, materialListAll, checkedMaterialProjectList, productMaterialProjectList, xproductMaterial) {
  console.log(projectMutexList)
  projectMutexList.forEach($obj => {
    if ($obj) {
      let projectIndex = projectIDList.findIndex($item => { return $item.id === $obj.id })
      let materialIndex = checkedMaterialProjectList.findIndex($item => { return $item.id === $obj.id })
      console.log(projectIndex  , materialIndex)
      if (projectIndex > -1 || materialIndex > -1) {
        if (materialIndex > -1) {
          checkedMaterialProjectList.splice(materialIndex, 1)
          // projectIndex > -1 && projectIDList.splice(projectIndex, 1)
        } else if(projectIndex > -1){
          projectIDList.splice(projectIndex, 1)
        }
      }
    if($obj.relationships) discardMaterialList($obj, projectIDList, productMaterialProjectList, checkedMaterialProjectList, xproductMaterial, materialListAll)
    }
  })
}

function getMaterialList (project, materialListAll, list, projectList, mater, next) {
  let arr = mater ? JSON.parse(JSON.stringify(mater)) : []
  let nextList = next && next.length ? next : []
  nextList.push(project)
  let newMaterialListAll = JSON.parse(JSON.stringify(materialListAll))
  let newList = JSON.parse(JSON.stringify(list))
  let newProjectList = JSON.parse(JSON.stringify(projectList))
  let relationshipList = project.relationships ? project.relationships.split(',') : []
  if (project.projectRelationshipDtoList && project.projectRelationshipDtoList.length) {
    project.projectRelationshipDtoList.forEach(item => {
      if (item.projectId.split(',').some($item => { return projectList.some($obj => { return $item === $obj.id && $item !== project.id }) })) {
        relationshipList = relationshipList.filter(obj => { return obj && !item.relationshipId.split(',').some($obj => { return $obj.split('*')[0] === obj }) })
      }
    })
  }
  if (arr && arr.length) {
    relationshipList = relationshipList.filter(obj => { return materialListAll.some(item => { return item.id === obj && item.recalculate.toString() !== '0' }) || !arr.some(item => { return item === obj }) })
    newMaterialListAll.filter(obj => { return obj.recalculate.toString() === '1' || !arr.includes(obj.id) })
  }
  relationshipList.forEach(obj => {
    newMaterialListAll.forEach(item => {
      if (obj === item.id) {
        if (item.recalculate.toString() === '1') {
          arr.push(item.id)
        } else {
          // nextList.push(item)
          if (item.relationships) {
            arr.push(item.id)
            if (!nextList.some($obj => { return $obj.id == item.id })) arr = getMaterialList(item, materialListAll, list, projectList, arr, nextList)
          } else {
            arr.push(item.id)
          }
        }
      }
    })
  })
  if (!mater) arr.shift()
  console.log(arr)
  return arr
}

function getCheckedMutex (project, MutexList, projectList) { //获取与之互斥的项目
  // console.log(project, MutexList, projectList)
  let MUTEX = []
  if (project[MUTEX_KEY]) {
    project[MUTEX_KEY].split(',').forEach($MUTEXID => {
      for (let key in MutexList[$MUTEXID]) {
        if (key !== project.id && MutexList[$MUTEXID][project.id] === 0 && MutexList[$MUTEXID][key] === 1) {
          MUTEX.push(key)
        } else if (MutexList[$MUTEXID][project.id] === 1) {
          MUTEX.push(key)
        }
      }
    })
  }
  return projectList.filter(obj => { return MUTEX.includes(obj.id) })
}

function getCheckedMutexALL (project, MutexList, checkedList) { //获取与之互斥的项目
  let MUTEX = []
  if (project[MUTEX_KEY]) {
    project[MUTEX_KEY].split(',').forEach($MUTEXID => {
      if ($MUTEXID && MutexList[$MUTEXID]) {
        MutexList[$MUTEXID].forEach($project => {
          MUTEX.push($project)
        })
      }
    })
  }
  return MUTEX
}

function discardMaterialList (project, checkedList, productMaterialProjectList, checkedMaterialProjectList, xproductMaterial, materialListAll) {

  let relationshipList =  getMaterialList(project, materialListAll, checkedMaterialProjectList, checkedList, [])
  if (project.projectRelationshipDtoList && project.projectRelationshipDtoList.length) {
    project.projectRelationshipDtoList.forEach(item => {
      if (item.projectId.split(',').some($item => { return checkedList.some($obj => { return $item === $obj.id && $item !== project.id }) })) {
        relationshipList = relationshipList.filter(obj => { return !item.relationshipId.split(',').some($obj => { return $obj.split('*')[0] === obj }) })
      }
    })
  }
  console.log(relationshipList)
  relationshipList.forEach($obj => {
    if ($obj && project.packable.toString() === '1' && productMaterialProjectList.some(obj=>{obj.id === $obj})) { //当前项目的在基础项目包或者套餐里面的
      productMaterialProjectList.forEach($item => {
        if ($item.id === $obj && $item.recalculate.toString() === '1') { //重复计费的
          $item.reduce = $item.reduce ? $item.reduce + 1 : 1
        } else if ($item.id === $obj) {
          if (!checkedList.some($t => { return $t.id !== project.id && $t.relationships.split(',').includes($obj) })) {
            productMaterialProjectList.splice(productMaterialProjectList.findIndex($t => { return $t === $obj }), 1)
            if(checkedMaterialProjectList && checkedMaterialProjectList.length){
              console.log()
              checkedMaterialProjectList.forEach($ismater => {
                if ($ismater.id === $obj) { //重复计费的
                  if ($ismater.recalculate.toString() !== '1') {
                    checkedMaterialProjectList.splice(checkedMaterialProjectList.findIndex($y => { return $y.id === $obj }), 1)
                  }
                }
              })
            }
          }

        }
      })
    } else if ($obj && project.packable.toString() === 'x' && xproductMaterial.some(obj=>{obj.id === $obj})) { //当前项目的在x项目
      console.log(project)
      xproductMaterial.forEach($item => {
        if ($item.id === $obj && $item.recalculate.toString() === '1') { //重复计费的
          $item.reduce = $item.reduce ? $item.reduce + 1 : 1
        } else if ($item.id === $obj) {
          if (!checkedList.some($t => { return $t.id !== project.id && $t.relationships.split(',').includes($obj) })) {
            // xproductMaterial.splice(xproductMaterial.findIndex($t => {return $t === $obj}), 1)
            checkedList.splice(checkedList.findIndex($y => { return $y.id === $obj }), 1)
          }
        }
      })
    } else if ($obj) { //用户自选的项目
      checkedMaterialProjectList.forEach($item => {
        console.log(project)
        if ($item.id === $obj) { //重复计费的
          if ($item.recalculate.toString() === '1') {
            $item.reduce = $item.reduce ? 1 : $item.reduce + 1
            if ($item.count - 1 > 0) {
              $item.count -= 1
            } else {
              $item.count = 0



              checkedMaterialProjectList.splice(checkedMaterialProjectList.findIndex($t => { return $t === $obj }), 1)
            }
          } else {
            if (!checkedList.some($t => { return $t.id !== project.id && $t.relationships.split(',').includes($obj) })) {
              checkedMaterialProjectList.splice(checkedMaterialProjectList.findIndex($y => { return $y.id === $obj }), 1)
              // checkedList.splice(checkedList.findIndex($y => { return $y.id === $obj }), 1)
            }
          }
        }
      })
    }
  })
}

function setMaterialList (project, projectIDList, ProjectList, materialListAll, checkedMaterial, productMaterial, xproductMaterial, nextProject) {

  let nextList = nextProject && nextProject.length ? nextProject : []



  let checkedList = checkedMaterial
  if (project.packable && project.packable.toString() === '1') {
    checkedList = productMaterial
  } else if (project.packable && project.packable.toString() === 'x') {
    checkedList = xproductMaterial
  }
  let relationshipList = getMaterialList (project, materialListAll, checkedList, projectIDList, [])
  relationshipList =relationshipList.filter(obj=>{ return obj !== project.id})
  console.log(relationshipList)
  if (project.projectRelationshipDtoList && project.projectRelationshipDtoList.length) {
    project.projectRelationshipDtoList.forEach(item => {
      if (item.projectId.split(',').some($item => { return projectIDList.some($obj => { return $item === $obj.id && $item !== project.id }) })) {
        relationshipList = relationshipList.filter(obj => { return obj && !item.relationshipId.split(',').some($obj => { return $obj.split('*')[0] === obj }) })
      }
    })
  }
  let materialList = checkedMaterial.concat(productMaterial).concat(xproductMaterial)
  let projectMutexList = []
  let initRelationshipList = []
console.log(relationshipList)
  relationshipList.forEach($obj => {
    if ($obj) {
      let $project = materialListAll.find(obj => { return obj.id === $obj })
      if ($project && $project.hasOwnProperty(MUTEX_KEY) && $project[MUTEX_KEY]) {
        $project[MUTEX_KEY].split(',').forEach(obj => {
          if (obj) {
            for (var key in isMutexList[obj]) {
              let checkedProject = checkedList.find(item => { return item.id === key && $obj.id !== key })
              let projectIDProject = projectIDList.find(item => { return item.id === key && $obj.id !== key })
              if ($obj !== key && ((!checkedProject && !projectIDProject) || (checkedProject && checkedProject.price < $project.price) || (projectIDProject && projectIDProject.price < $project.price) || (isMutexList[obj][key] === 0 && isMutexList[obj][$obj] === 0))) {
                if ((!checkedProject && !projectIDProject) || (isMutexList[obj][key] === 0 && isMutexList[obj][$obj] === 0)) {
                  initRelationshipList.push($obj)
                } else if ((checkedProject && checkedProject.price < $project.price) || (projectIDProject && projectIDProject.price < $project.price)) {
                  initRelationshipList.push($obj)
                  projectMutexList.push(checkedProject || projectIDProject)
                }
              }
            }
          }
        })
      } else {
        initRelationshipList.push($obj)
      }
    }
  })
  console.log(initRelationshipList)
  initRelationshipList.forEach($item => {
    // 先看是否为 重复计费 ： 不重复的 则先检查 projectIDList 是否有 。 若无则增加
    if ($item && !projectIDList.some(obj => { return obj.id === $item }) && !nextList.some(obj => { return obj.id === $item })) {

      if (project.packable && (project.packable.toString() === '1' || project.packable.toString() === 'x')) {
        console.log('123')
        if (checkedList.some(obj => { return obj.id === $item })) {
          checkedList.forEach($obj => {
            if ($obj.id === $item && $obj.recalculate.toString() === '1') {
              if ($obj.reduce > 0) {
                $obj.reduce++
              }
            }
          })
        }else {
          console.log('checkede')
          let $project = ProjectList.find(obj=>{return obj.id === $item})
          if($project.packable === '1' || $project.packable === 'x')
            projectIDList.push($project)
        }
      } else {
        console.log('456')
        if (checkedList.some(obj => { return obj.id === $item })) {
          checkedList.forEach($obj => {
            if ($obj.id === $item && $obj.recalculate.toString() === '1') {
              $obj.count += 1
            }
          })
        } else {
          materialListAll.forEach($obj => {
            if ($obj.id === $item && $obj.recalculate.toString() === '0') {
              //不重复计费


              if (!(materialList.some(r => { return $item === r.id }) && !projectIDList.some(t => { return $item === t.id }))) {
                $obj.count = 1
                $obj.reduce = 0
                $obj.packable = $obj.packable ? $obj.packable.toString() : '0'
                console.log( project.packable)
                if( project.packable !== '1'  && project.packable !== 'x')
                    checkedList.push($obj)
                  else
                    projectIDList.push($obj)

              }
            } else if ($obj.id === $item) {
              console.log($obj.item)
              //重复计费
              checkedList.push(Object.assign({}, $obj, {count: 1, reduce: 0}))
            }
          })
        }
      }
    }
  })
  // console.log(checkedList)
  console.log(projectMutexList)
  if(projectMutexList && projectMutexList.length)
  mutexReplace(projectMutexList, projectIDList, materialListAll, checkedMaterial, productMaterial, xproductMaterial)
}

function checkProject (project, allProjectList, checkedProjectList, mutexProjectList) {
  let projectList = []
  if (mutexProjectList && mutexProjectList.length > 0) {
    let uncheckProjectList = []
    projectList = [].concat(checkedProjectList)
    for (let mutexProject of mutexProjectList) {
      if ((mutexProject.base === 1 || mutexProject.packable === 1) && mutexProject.replaceable !== '1') {
        Toast.fail({
          duration: 3000,
          forbidClick: true,
          message: `该项目与${mutexProject.packable === 1 ? '套餐' : '基础项目包'}中的【${mutexProject.item}】项目不能同时选择`
        })
        return projectList
      } else if (mutexProject.packable === 1 && mutexProject.replaceable === '1' && project.price < mutexProject.discountPrice) {
        Toast.fail({
          duration: 2500,
          forbidClick: true,
          message: `该项目与${mutexProject.packable === 1 ? '套餐' : '基础项目包'}中的【${mutexProject.item}】项目不能同时选择`
        })
        return projectList // 互斥组中包含套餐项目,并且套餐项目为可替换,如果当前选择项目价格低于套餐项目,则不可操作
      } else if (checkedProjectList.some(p => p.id === mutexProject.id)) {
        if ((mutexProject.base === 1 || mutexProject.packable === 1) && mutexProject.replaceable === '1') {
          uncheckProjectList.push(mutexProject)
        } else if (mutexProject.base !== 1 && mutexProject.packable !== 1) {
          uncheckProjectList.push(mutexProject)
        }
      }
    }
    projectList = projectList.filter((p) => !uncheckProjectList.some((sp) => p.id === sp.id))
    if (!checkedProjectList.some(p => p.id === project.id) && project.packable !== 1) {
      projectList = projectList.concat([project])
    }
  } else if (!checkedProjectList.some(p => p.id === project.id)) {
    projectList = project.packable !== 1 ? checkedProjectList.concat([project]) : checkedProjectList
  }
  return projectList
}

function getCheckedProjectList (project, allProjectList, checkedProjectList) {
  let projectList = []
  console.log(project)
  let mutexProjectList = getMutexProjectRelation(project, allProjectList)
  if (checkedProjectList.some(p => p.id === project.id)) {
    // 取消选项,并处理互斥组关系
    projectList = unCheckProject(project, allProjectList, checkedProjectList, mutexProjectList)
  } else {
    // 添加项目
    projectList = checkProject(project, allProjectList, checkedProjectList, mutexProjectList)
  }
  return projectList
}

function getMutexProjectRelation (project, projectList) {
  let projects
  let mutexIds = []
  let mutexProjectList = []
  if (project.mutexId && typeof project.mutexId === 'string') {
    mutexIds = project.mutexId.split(',') || []
  }
  for (let id of mutexIds) {
    projects = getTreeList(projectList, id, MUTEX_KEY)
    for (let obj of projects) {
      if (obj.mutexId && project.id !== obj.id && !mutexProjectList.find((p) => p.id === obj.id)) {
        mutexProjectList.push(obj)
      }
    }
  }
  return mutexProjectList
}

function getMaterialProjectList (checkedProjectList, materialList) {
  let materialProjectList = []
  let materialIds, materialProject
  for (let checkedProject of checkedProjectList) {
    if (checkedProject.relationships && typeof checkedProject.relationships === 'string') {
      materialIds = checkedProject.relationships.split(',') || []
      for (let id of materialIds) {
        if (checkedProjectList.some(p => p.id === id)) {
          continue
        }
        materialProject = materialList.find((p) => p.id === id)
        if (materialProject) {
          materialProjectList.push(materialProject)
          if (materialProject.relationships) {
            let arrNew = []
            arrNew.push(materialProject)
            getMaterialProjectList(arrNew, materialList).map(item => {
              materialProjectList.push(item)
            })
          }
        }
      }
    }
  }
  return materialProjectList
}

function getClassListByProject (project, projectClassList) {
  let items = []
  for (let type of projectClassList) {
    for (let item of type.items) {
      if (item.id === project.id || item.projectId === project.id) {
        items.push(type.id)
        break
      }
    }
  }
  return items.join(',')
}

function getProjectTreeList (projectList) {
  return getTreeListByOrderNum(projectList, '', PARENT_KEY)
}

/**
 * 通过递归获取树形结构数据
 * @param list 数据集合
 * @param keyword 关系值
 * @param key 关系key
 * @param childrenKey 子集key(默认值：children)
 * @returns {Array} 符合要求的树形结构数据
 */
function getTreeList (list, keyword, key, childrenKey) {
  let array = []
  for (let node of list) {
    if (node.hasOwnProperty(key) && (`,${node[key]},`).indexOf(`,${keyword},`) > -1) {
      node[childrenKey || 'children'] = getTreeList(list, node.id, key, childrenKey)
      array.push(node)
    }
  }
  return array
}

/**
 * 通过递归获取树形结构数据
 * @param list 数据集合
 * @param keyword 关系值
 * @param key 关系key
 * @param childrenKey 子集key(默认值：children)
 * @returns {Array} 符合要求的树形结构数据
 */
function getTreeListByOrderNum (list, keyword, key, childrenKey) {
  let array = []
  for (let node of list) {
    if (node.hasOwnProperty(key) && (`,${node[key]},`).indexOf(`,${keyword},`) > -1) {
      node[childrenKey || 'children'] = getTreeList(list, node.id, key, childrenKey)
      node[childrenKey || 'children'] = node[childrenKey || 'children'].sort(function (a, b) {
        return ((a.orderNum < b.orderNum) ? -1 : ((a.orderNum > b.orderNum) ? 1 : 0))
      })
      array.push(node)
    }
  }
  return array
}

function replaceTree (projectList, isTreeList) {
  let arr = []
  isTreeList.forEach(obj => {
    if (obj.children && obj.children.length) {
      let {item, id, orderNum, parentId, parentName, inspectionSignificance} = obj
      let children = replaceTree(projectList, JSON.parse(JSON.stringify(obj.children)))
      // let visible = children.every(obj => { return visible === 0 }) ? 0 : 1
      let showList = children.filter(project => { return project.visible === 1 })
      if (obj.isMutexGroupProject === 1) {
        if (showList.length) {
          arr.push({
            item: item.replace(/[0-9]+/, showList.length),
            id,
            orderNum,
            parentId,
            parentName,
            inspectionSignificance,
            children,
            typable: '1',
            visible: 1
          })
        } else {
          arr.push({
            item,
            id,
            orderNum,
            parentId,
            parentName,
            inspectionSignificance,
            children,
            typable: '1',
            visible: 0
          })
        }
      } else {
        arr.push({item, id, orderNum, parentId, parentName, inspectionSignificance, children, typable: '1', visible: 1})
      }
      // arr.push({item, id, orderNum, parentId, parentName, inspectionSignificance, children, typable: '1', visible})
    } else {
      for (let i = 0; i < projectList.length; i++) {
        if (obj.id === projectList[i].id) {
          arr.push(projectList[i])
          break
        }
      }
    }
  })
  return arr
}

function getProjectMutexList (isTreeList) {
  let isMutex = {}
  isTreeList.forEach(obj => {
    if (obj.children && obj.children.length && obj.typable === '1') {
      Object.assign(isMutex, getProjectMutexList(obj.children))
    } else if (obj.children && obj.children.length) {
      let children = {}
      obj.children.forEach(project => {
        children[project.id] = project.exclusive
      })
      isMutex[obj.id] = children
    }
  })
  return isMutex
}

export default {
  replaceTree,
  getProjectMutexList,
  getCheckedProject, //获取体检项目
  getCheckedProjectMUTEX,
  getUnSelectProject,
  getMutexProjectRelation,
  getMaterialProjectList,
  getCheckedProjectList,
  getClassListByProject,
  getProjectTreeList,

  getTreeList
}
